export default [
    {
        name: 'Trading',
        path: `/:locale(${process.env.VUE_APP_AVAILABLE_LOCALES})?/:market?/:base?/:counter?`,
        component: () => import('./View.vue'),
    },
];
